import { Typography } from '@mui/material';

export const Screen7ParadigmShifts = ({ selectedIndustry }) => {
  if (!selectedIndustry) return null;

  return (
    <div className="p-6 text-center">
      <Typography fontSize={35} textAlign="center">
        Paradigm Shifts
      </Typography>
      <div className="mt-8">
        {Object.entries(selectedIndustry.ParadigmShifts).map(([key, value]) => (
          <div key={key} className="mb-8">
            <Typography fontSize={22} fontWeight={600} textAlign="center">
              {key}
            </Typography>
            <Typography fontSize={19} mt={2} lineHeight={1}>
              {value.from}
            </Typography>
            <Typography fontSize={19} my={1}>
              to
            </Typography>
            <Typography fontSize={19} lineHeight={1}>
              {value.to}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
};
